import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { accessAllowed } from '../services/subscriptionService';
import './GameCard.css';

const GameCard = ({ game, onGameClick }) => {
  const navigate = useNavigate();
  const [hasAccess] = useState(true);
  const [showPremiumTag] = useState(false);
  const [imgError, setImgError] = useState(false);
  
  const handleCardClick = () => {
    if (hasAccess) {
      onGameClick(game.id);
    } else {
      navigate('/subscription');
    }
  };

  const handleImageError = (e) => {
    console.log('Image failed to load:', game.thumbnail);
    setImgError(true);
    e.target.src = '/q.png';
  };

  return (
    <div className="game-card" onClick={handleCardClick}>
      <div className="game-card-image">
        <img 
          src={game.thumbnail} 
          alt={game.title}
          onError={handleImageError}
          loading="lazy"
        />
      </div>
      <div className="game-info">
        <h3>{game.title}</h3>
        <p>{game.description}</p>
        <div className="game-stats">
          <span>⭐ {game.rating}</span>
          <span>🎮 {game.plays}</span>
        </div>
      </div>
      {showPremiumTag && <div className="game-card-overlay">🔒 Premium</div>}
    </div>
  );
};

export default GameCard;
